


























import { RulesCard } from '@/components/rules';
import { GrantingItem } from '@/components/rules/card-items';
import { GratificationActivity, Gratification } from '@/models/rules';
import { Skill } from '@/models';
import Vue from 'vue';

interface GratificationActivityWithSkill extends GratificationActivity {
  skill: Skill;
  parent?: GratificationActivity;
}

export default Vue.extend({
  name: 'GrantingCards',
  components: {
    GrantingItem,
    RulesCard: () => Promise.resolve(RulesCard),
  },
  props: {
    data: Array as () => Gratification[],
  },
  computed: {
    // This method would flattten all gratifications
    // into a single array in order to display all of them in cards as separate items (mobile)
    gratifications(): GratificationActivityWithSkill[] {
      return this.data.reduce((allItemsInSkills: GratificationActivityWithSkill[], currentSkill: Gratification) => {
        const activitiesWithSkills = currentSkill.gratifications
          .reduce((allItemsInActivities: GratificationActivityWithSkill[], activityType: GratificationActivity) => {
            const allActivityTypes: GratificationActivityWithSkill[] = [
              {...activityType, skill: currentSkill.skillType},
            ];

            return allActivityTypes.concat(allItemsInActivities);
          }, []);

        return allItemsInSkills.concat(activitiesWithSkills);
      }, []);
    },
  },
});
